(() => {
  if (window.__icsCartPageBound) return;
  window.__icsCartPageBound = true;

  const rowsForRfq = (root) => {
    const rows = Array.from((root || document).querySelectorAll('[data-cart-row]'));
    const checked = rows.filter((row) => row.querySelector('.ics-cart-select:checked'));
    const selected = checked.length ? checked : rows;
    return selected.map((row) => ({
      mpn: row.dataset.mpn || '',
      manufacturer: row.dataset.manufacturer || '',
      quantity: Number(row.querySelector('[name="updates[]"]')?.value || row.dataset.quantity || 1),
    })).filter((row) => row.mpn && row.quantity > 0);
  };

  document.addEventListener('click', (event) => {
    const rfq = event.target.closest('[data-cart-rfq]');
    if (rfq) {
      const rows = rowsForRfq(document);
      if (!rows.length) {
        event.preventDefault();
        window.alert('Add at least one item before submitting an RFQ.');
        return;
      }
      sessionStorage.setItem('ics-bom-rfq-lines', JSON.stringify({
        source: 'Prepared from Shopping List',
        rows,
        timestamp: new Date().toISOString(),
      }));
    }

    const save = event.target.closest('[data-cart-save]');
    if (save) {
      const rows = rowsForRfq(document);
      localStorage.setItem('ics-cart-saved-list', JSON.stringify({ rows, savedAt: new Date().toISOString() }));
      const status = document.querySelector('[data-cart-save-status]');
      if (status) status.textContent = 'Saved for later';
    }
  });
})();
